<template>
    <div class="v-progress-linear v-progress-linear--active v-progress-linear--rounded v-progress-linear--rounded v-theme--p8ntrTheme v-locale--is-ltr" role="progressbar" aria-hidden="false" aria-valuemin="0" aria-valuemax="100" :aria-valuenow="progress" style="top: 0px; height: 7px; --v-progress-linear-height: 7px;">
        <div class="v-progress-linear__background bg-grey-lighten-4" style="opacity: 1; width: 100%;"></div>
        <div class="v-progress-linear__determinate bg-blue-lighten-1" :style="{ 'width' : progress+'%' }"></div>
    </div>
</template>
<style scoped>
    .v-progress-linear {
        display:inline-flex;
    }
    .v-progress-linear__determinate {
        position:relative;
    }
</style>
<script>
    import { numberWithCommas } from "../mixins/numberMixins";
    function initialState() {
        return {
            loading: false
        };
    }
    export default {
        name: "LineProgressBar",
        data: function () {
            return initialState();
        },
        mounted: function () {
        },
        props: {
            progress: Number,
        },
        methods: {
            numberWithCommas
        },
        computed: {
        }
    };
</script>